import { onDocumentEvent } from '@app/utils/domHelpers'

const toggleSubAdjustments = (e) => {
  e.preventDefault()
  const subAdjustmentElementSelector = e.target.getAttribute('href')
  const subAdjustmentElement = document.querySelector(
    subAdjustmentElementSelector
  )

  if (subAdjustmentElement) {
    const currentDisplay = subAdjustmentElement.style.display
    subAdjustmentElement.style.display =
      currentDisplay === 'none' ? 'block' : 'none'
  }
}

onDocumentEvent(
  document,
  'click',
  '[data-behaviour="toggle-adjustments-table"]',
  toggleSubAdjustments
)
